import Component, { mixins } from "vue-class-component";
import { ApplicationUserRoleMixin } from "@/mixins";

@Component
export class XtrtUserRoleMixin extends mixins(ApplicationUserRoleMixin) {
    async mounted(): Promise<void> {
        await this.$store.dispatch("xtrt/loadValidators");
    }
}
